import { Firma } from '../../api/person-api.types';
import { ResolveFn } from '@angular/router';
import { PersonApiService } from '../../api/person-api.service';
import { inject } from '@angular/core';

export const companiesResolver: ResolveFn<Firma[]> = () => {
  return inject(PersonApiService).getAllCompanies();
};
